import React from 'react';
import { Img } from '@chakra-ui/react';
import { Global } from '@emotion/react';
import logo from '@/assets/sugarcastle/images/logos/logoCenter.png';
import { TTemplate } from '@/helpers/createTemplate';
import ButtonRefresh from '../components/ButtonRefresh';
import Description from '../components/Description';
import Title from '../components/Title';
import {
  FlexPageWrapper,
  MaintenanceContainer,
} from '../styles/Maintenance.styles';

const { REACT_APP_THEME_NAME } = window.BETCLOUD_ENV;

const template = (isMaintenance: boolean): TTemplate => ({
  wrapper: <FlexPageWrapper isMaintenance={isMaintenance} />,
  content: {
    wrapper: <MaintenanceContainer />,
    logo: (
      <Img src={logo} alt={REACT_APP_THEME_NAME} alignSelf="center" w="250px" />
    ),
    title: <Title />,
    desc: <Description />,
    btn: <ButtonRefresh />,
    body: (
      <Global styles={{ body: { background: 'var(--bc-colors-gray-400)' } }} />
    ),
  },
});

export default template;
